import React from 'react'
import classNames from 'classnames'
import { Modal as BootstrapModal } from 'react-bootstrap'
import { Modal } from '../../../components/Modal/Modal'
import { Button } from '../../../components/Button/Button'
import styles from './DeleteExecutionConfirmModal.module.scss'

const buttonClassName = 'rounded-3 paragraph-medium bold'

interface DeleteExecutionConfirmModalProps {
  show: boolean
  userQuestion?: string
  onCancel: () => void
  onConfirm: () => void
  loading?: boolean
}

export const DeleteExecutionConfirmModal: React.FC<DeleteExecutionConfirmModalProps> = ({ show, userQuestion, onCancel, onConfirm, loading = false }) => {
  const header = (
    <BootstrapModal.Title as='h2' className={`${styles.title} fw-bold mb-0 zocks-text-gray-900`}>
      Delete this query?
    </BootstrapModal.Title>
  )

  const body = (
    <div className='d-flex flex-column gap-4 paragraph-medium zocks-text-gray-900'>
      {userQuestion ? <p className='mb-0'>{`“${userQuestion}”`}</p> : null}
      <p className='mb-0'>You&apos;ll lose this query and everything tied to it, including matches and action history. You can&apos;t undo this.</p>
    </div>
  )

  const footer = (
    <div className='d-flex gap-3'>
      <Button variant='secondary' className={buttonClassName} onClick={onCancel}>
        Cancel
      </Button>
      <Button variant='danger' className={classNames(styles.deleteButton, buttonClassName)} loading={loading} onClick={onConfirm}>
        Delete query
      </Button>
    </div>
  )

  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={header}
      headerClassName='zocks-pt-2.0 zocks-px-2.0 zocks-pb-1.25'
      body={body}
      bodyClassName='py-3'
      centered
      dialogClassName={styles.dialog}
      footer={footer}
      footerClassName='zocks-pt-1.25'
    />
  )
}
